/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCompetitionFairPnlStandingsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetCompetitionFairPnlStandingsArgs, useGetCompetitionFairPnlStandingsSpec, useGetCompetitionFairPnlStandingsRealtime, useGetCompetitionFairPnlStandingsPagination } from '../specs/competitions.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetCompetitionFairPnlStandingsRow } from '../openapi-types.gen.js';
export type { useGetCompetitionFairPnlStandingsArgs } from '../specs/competitions.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetCompetitionFairPnlStandingsPaginationContract = useGetCompetitionFairPnlStandingsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetCompetitionFairPnlStandingsInfinite` — both
 * read/write the same `PagedData<GetCompetitionFairPnlStandingsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): competitionId, limit, cursor.
 */
const _useGetCompetitionFairPnlStandings = createListHook({
  spec: useGetCompetitionFairPnlStandingsSpec,
  realtime: useGetCompetitionFairPnlStandingsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionFairPnlStandingsPaginationContract,
});
export const useGetCompetitionFairPnlStandings = _useGetCompetitionFairPnlStandings as (args: useGetCompetitionFairPnlStandingsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionFairPnlStandings>;


/**
 * Auto-infinite: same cache as `useGetCompetitionFairPnlStandings`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetCompetitionFairPnlStandings` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetCompetitionFairPnlStandingsInfinite = createListHook({
  spec: useGetCompetitionFairPnlStandingsSpec,
  realtime: useGetCompetitionFairPnlStandingsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionFairPnlStandingsPaginationContract,
  autoLoadMore: true,
});
export const useGetCompetitionFairPnlStandingsInfinite = _useGetCompetitionFairPnlStandingsInfinite as (args: useGetCompetitionFairPnlStandingsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionFairPnlStandingsInfinite>;


/**
 * Per-field subscription hook for the `useGetCompetitionFairPnlStandings` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetCompetitionFairPnlStandingsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetCompetitionFairPnlStandingsField = createFieldHook<GetCompetitionFairPnlStandingsRow>('useGetCompetitionFairPnlStandingsField');

/**
 * Hover/intent prefetch companion for `useGetCompetitionFairPnlStandings` (also covers
 * `useGetCompetitionFairPnlStandingsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetCompetitionFairPnlStandings();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetCompetitionFairPnlStandings = createPrefetchHook(useGetCompetitionFairPnlStandingsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCompetitionFairPnlStandingsArgs>;
